module.exports = __webpack_public_path__ + "img/medalha-municipio-mais-simples.a301d522.jpg";